export const environment = {
  production: false,
  strEnvironment: 'Development',
  // Dev API
  // api: 'http://localhost:8080/api/v1',
  api: '/api/v1',
  components_visibility:{
    home_panel_sales: false,
    home_panel_payments: false,
    home_panel_commissions: true,
    home_panel_settlements: true,
    home_panel_invoices: true,
    home_panel_payOrders: true,    
  },
  broker_profile:{
    broker_profile_button_edit_hidden: true,
    broker_profile_button_edit_disable: true,
    broker_profile_fields_disable: true,
  },
  recaptchaSiteKey: '6Lc6MG8tAAAAAGKVh3B3VMRt7kVOoECX7pK9G-8f'
};
